import { HOMEOFFICE_SYSTEM_URL, SERVICE_NAME } from '../../constants/AppConstants';

const SiteMaintenance = () => {
  document.title = SERVICE_NAME;

  return (
    <div className="govuk-grid-row">
      <div className="govuk-grid-column-two-thirds">
        <h1 className="govuk-heading-xl" data-testid="landing-h1">Sorry, the service is unavailable</h1>
        <p>Please try again later.</p>
        <p data-testid="textWithLink"><a href={HOMEOFFICE_SYSTEM_URL} target="_blank" rel="noreferrer">Check report data in CBP</a> if you need to see information urgently.</p>
      </div>
    </div>
  );
};

export default SiteMaintenance;
